import React from "react";
import Fa from 'react-fontawesome'
import { Tab, Tabs} from 'react-bootstrap'
import { backend } from '../settings'
import cookie from 'react-cookie'

export default class DisplayInfo extends React.Component {
    constructor(props) {
    super(props)
    this.state = {nextImageDoesNotExist : false}  
  }

  componentDidMount() {
    document.getElementById('display-selector-tab-0').click()
  }

  componentWillReceiveProps() {
    document.getElementById('display-selector-tab-0').click()
  }

  render() {
     let displays = this.props.displays
     let imgurl = backend + '/api/image/' + this.props.device + '?Authorization=Bearer ' + cookie.load('token') + '&thumbnail=true&display='
     let rotations = [0,180,90,270]
     let icons = ['circle-o', 'circle-o','repeat','undo']

     let avail_disp = displays.map((item,i) =>             
        <Tab eventKey={i} title={item.display_id} key={i}>
          <p></p>
          <p>
            <b><Fa name='tablet' title='display id'/> </b> {item.display_id} {item.virtual ? '(virtual)' : '(physical)'}
            <br/>
            <b><Fa name='arrows-alt'/></b> {item.res_x} x {item.res_y}
          
          { !item.virtual &&
                    <span><br/> 
                    <b> <Fa name={icons[rotations.indexOf(item.rotation)]} /></b> {item.rotation === 0 || item.rotation === 180 ? 'Portrait ' : 'Landscape ' }
                     ({item.rotation} deg)</span>
          }   

          </p>

            <Tabs defaultActiveKey={55} id="image-selector" >
              <Tab eventKey={55} title='Current image'  >
              <p/>
              <img src={imgurl + item.display_id } style={{maxWidth:400, border: '25px solid #141313'}} alt={item.display_id}/>
              </Tab>

              <Tab eventKey={56} title='Next image' disabled={this.state.nextImageDoesNotExist}>
              <p/>
              <img src={imgurl + item.display_id + '&next=true'} 
                   onError={() => this.setState({nextImageDoesNotExist: true})}
                   style={{maxWidth:400, border: '25px solid #141313'}} alt={item.display_id}/>
              </Tab>

            </Tabs>


        </Tab>)



      return (
            <div>
            <Tabs defaultActiveKey={0} id="display-selector" >
              {avail_disp}
             </Tabs>
            <div>

            </div>
            </div>
       )

  }
}



// WEBPACK FOOTER //
// ./src/components/DisplayInfo.js